var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7649,
    cy: 18.1478,
    r: 18,
    fill: "#E5E6EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4732 16.6548C26.4409 18.7659 25.8377 20.4892 24.6098 21.9864C22.9188 24.0328 21.2385 26.0901 19.5475 28.1366C19.1059 28.6643 18.632 28.6643 18.1904 28.1366C16.4347 25.9931 14.636 23.8821 12.9234 21.7063C10.4677 18.5828 10.78 13.9513 13.5912 11.2478C15.2499 9.66451 17.2533 9.01825 19.5367 9.16905C22.5418 9.37369 25.6977 11.5602 26.3655 15.5346C26.4409 15.9655 26.4516 16.3963 26.484 16.6548H26.4732ZM18.8905 13.6174C17.2318 13.6174 15.8962 14.9422 15.8962 16.6009C15.8962 18.2381 17.2318 19.5737 18.8689 19.5845C20.5061 19.5845 21.8525 18.2489 21.8525 16.6117C21.8525 14.9638 20.5169 13.6174 18.8905 13.6174Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.fd0544af68418f06c17d3f863c37eb06.svg";
export { ForwardRef as ReactComponent };